import _extends from 'babel-runtime/helpers/extends';

export default {
  props: {
    content: {
      type: [String, Number],
      default: ''
    },

    maxLength: {
      type: Number,
      default: Infinity
    },

    tooltipProps: {
      type: Object
    },

    showQuestion: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    innerTooltipProps: function innerTooltipProps() {
      return _extends({
        popperClass: 'auto-tips-content',
        placement: 'top',
        effect: 'light'
      }, this.tooltipProps);
    }
  }
};